// site scss bundle - will be extracted into a css file by ExtractTextPlugin
import '../c/main.scss'

import './util/polyfills'

import './src/site'

import './src/projects/index'
import './src/projects/students'
import './src/projects/project'

import './src/features/index'
import './src/features/feature'

import './src/about'
import './src/books'



// WEBPACK FOOTER //
// ./assets/j/main.js